import { useSelector } from 'react-redux';

import { useAppDispatch } from 'store';

import { getProgressMediaList } from '../../../../../store/slices/dashboardSlice/action';
import { dashboardActions } from '../../../../../store/slices/dashboardSlice/dashboardSlice';

export const useAlbums = () => {
    const dispatch = useAppDispatch();
    // @ts-ignore
    const { albums, selectedAlbums } = useSelector((state) => state.dashboardReducer);

    const onSetActiveAlbums = (id?: string) => () => {
        dispatch(dashboardActions.onChangeSelectedAlbums(id));
        dispatch(getProgressMediaList());
    };

    return { albums, onSetActiveAlbums, selectedAlbums };
};
